var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('cbr-manual-form',{attrs:{"form-data":_vm.formData,"config":_vm.config}}),_vm._v(" "),_c('cbr-choose-return-method',{directives:[{name:"show",rawName:"v-show",value:(_vm.formIsValid),expression:"formIsValid"}]}),_vm._v(" "),_c('cbr-summary',{directives:[{name:"show",rawName:"v-show",value:(_vm.formIsValid),expression:"formIsValid"}]})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79fc16f6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/ManualEntryPage.vue
// module id = 157
// module chunks = 0